const QF = "https://booking.quickferries.com?yafl=fWh4TCGCOG67TvrF";
export const QF_URL = QF;
// Ricerca con tratta preselezionata: route id dal modulo pubblico QuickFerries (1441 Amalfi→Positano, 3707 Amalfi→Capri), data ISO di oggi (Roma).
export const qfRoute = (rid) => `https://booking.quickferries.com/results?yafl=fWh4TCGCOG67TvrF&departure_route_id=${rid}&departure_data=${new Date().toLocaleDateString("en-CA", { timeZone: "Europe/Rome" })}&adulti=2`;

export const QF_T = {
  en: "Book Ferry Tickets", it: "Prenota biglietti traghetto", fr: "Réserver des billets de ferry", de: "Fährtickets buchen", es: "Reservar billetes de ferry",
};

export const trackFerry = (channel, slug) => {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/ferry-click`, {
      method: "POST", keepalive: true, headers: { "Content-Type": "application/json" }, body: JSON.stringify({ channel, slug: slug || null }),
    }).catch(() => {});
  } catch (e) { /* tracking must never block the link */ }
};
